import { defineAsyncComponent } from "vue";

export default [
  {
    name: "NotebookEditorCover",
    component: defineAsyncComponent(
      () => import("@modules/notebook-editor/components/NotebookEditorCover.vue"),
    ),
    path: "",
    props: true,
  },
  {
    name: "NotebookEditorPage",
    component: defineAsyncComponent(
      () => import("@modules/notebook-editor/components/NotebookEditorPage.vue"),
    ),
    path: "page/:pageId",
    props: true,
  },
  {
    path: "not-found",
    name: "NotebookEditorNotFoundPage",
    component: defineAsyncComponent(
      () => import("@modules/notebook-editor/components/NotebookEditorNotFoundPage.vue"),
    ),
  },
];
